import { Selector } from "@ngxs/store";
import { SampleState, SampleStateModel } from "./sample.state";

export class SampleGetterState {
    @Selector([SampleState])
    static getSampleCount(state: SampleStateModel) {
        return state.count;
    }

    @Selector([SampleState])
    static getHash(state: SampleStateModel) {
        return state.hash;
    }

    @Selector([SampleState])
    static getStoredSampleCounts(state: SampleStateModel) {
        return state.knownSampleCounts;
    }
}